import {
	Button,
	TextField,
	Typography,
	Box,
	IconButton,
	Radio,
	RadioGroup,
	InputAdornment,
} from '@barracuda-internal/bds-core-v2';
import React, { ChangeEvent, ReactElement, useState } from 'react';
import { SearchProps } from 'src/routes/settings/UserSettings';
import { CloseSharp } from '@material-ui/icons';

interface Props {
	isSearching: boolean;
	onSearch: (search: SearchProps) => void;
}

function UserSearch({ isSearching = false, onSearch }: Props): ReactElement {
	const [searchText, setSearchText] = useState('');
	const [searchType, setSearchType] = useState<'name' | 'email'>('name');

	const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
		setSearchText(e.target.value);
		if (e.target.value === '') {
			onSearch({
				type: searchType,
				text: '',
			});
		}
	};

	const handleSearchClick = () => {
		if (searchText !== '') {
			onSearch({
				type: searchType,
				text: searchText.trim(),
			});
		}
	};

	const handleSearchTypeChange = (e) => {
		setSearchType(e.target.value);
		if (searchText) {
			onSearch({
				type: e.target.value,
				text: searchText,
			});
		}
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		handleSearchClick();
	};

	const handleClearSearch = () => {
		if (searchText !== '') {
			setSearchText('');
			onSearch({
				type: searchType,
				text: '',
			});
		}
	};

	return (
		<form onSubmit={handleSubmit}>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
				<TextField
					size="small"
					label="Search"
					onChange={handleSearchChange}
					value={searchText}
					variant="outlined"
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton
									size="small"
									onClick={handleClearSearch}
									aria-label="Clear search"
								>
									<CloseSharp fontSize="small" />
								</IconButton>
							</InputAdornment>
						),
					}}
				/>
				<Button
					disabled={isSearching}
					isLoading={isSearching}
					onClick={handleSearchClick}
					variant="contained"
					color="primary"
				>
					Search
				</Button>
			</Box>
			<RadioGroup
				row
				onChange={handleSearchTypeChange}
				value={searchType}
				style={{ marginTop: 8 }}
			>
				<Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
					<Radio value="name" color="primary" />
					<Typography variant="body1">Search By Name</Typography>
				</Box>
				<Box sx={{ display: 'flex', alignItems: 'center' }}>
					<Radio value="email" color="primary" />
					<Typography variant="body1">Search By Email</Typography>
				</Box>
			</RadioGroup>
		</form>
	);
}

export default UserSearch;
